import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-statics-cookies",
  templateUrl: "./statics-cookies.component.html",
  styleUrls: ["./statics-cookies.component.scss"],
})
export class StaticsCookiesComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  close() {
    this.router.navigate(["/"]);
  }
}
